import React, { useEffect, useState } from 'react';
import styles from './prize.css';

/**
 *
 * @type {React.NamedExoticComponent<{readonly prize?: *, readonly key?: *}>}
 */

const Prizes = React.memo( ( {  prize } ) => {

    const [ logo_id, setLogoId ] = useState( null );
    const [ title, setTitle ] = useState( '' );
    const [ description, setDescription ] = useState( '' );

    useEffect( () => {
        if ( prize ) {
            setLogoId( prize.logo ? prize.logo.url : null );
            setTitle( prize.title );
            setDescription( prize.description );

        }

    }, [] );

    const backImg = logo_id ? logo_id : 'https://static.umotive.com/img/product_image_thumbnail_placeholder.png';

    return (
        <div   className={ styles.wrapper }>
            <div className={ styles.imageBox }>
                <div className={ styles.image }
                     style={ { backgroundImage: `url(${ backImg })` } }/>
            </div>
            <div className={ styles.inputsWrapper }>
                <h4 className={ styles.title }>{ title }</h4>
                <p className={ styles.description }>{ description }</p>
            </div>
        </div>
    );

} );

export default Prizes;